import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { ISeo, ISeoParagraph, SdSeoWrapperComponent } from '@seb/web-design-system/seos';
import { PositionEnum } from '@seb/web-design-system/core';

import { toHeading, transformHeadlineLevelToTitleLevel } from '../../../mappers';
import { SeoComponentInterface, SeoModuleInterface } from '../../../models';
import { AbstractModuleComponent } from '../abstract-module.component';
import { ImageService } from '../../../services';
import { CmsService } from '@spartacus/core';

@Component({
  selector: 'wc-seo-module',
  templateUrl: './seo-module.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdSeoWrapperComponent]
})
export class SeoModuleComponent extends AbstractModuleComponent<SeoModuleInterface> implements OnInit {
  seo: ISeo;
  private pageType: string | undefined;

  constructor(
    private imageService: ImageService,
    private cdRef: ChangeDetectorRef,
    private cmsService: CmsService
  ) {
    super();
  }

  override mandatoryFunction = (cmp: SeoModuleInterface): boolean => {
    return !!cmp.headline;
  };

  override mandatoryComponentFunction = (cmp: SeoComponentInterface): boolean => {
    return !!cmp.headline && !!cmp.description;
  };

  ngOnInit(): void {
    this.subscriptions.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        this.pageType = page.template;
        this.module$.subscribe((module: SeoModuleInterface) => {
          this.seo = this.toSeo(module);
          this.setLoaded();
          this.cdRef.detectChanges();
        });
      })
    );
  }

  private toParagraph(cmp: SeoComponentInterface): ISeoParagraph {
    return {
      heading: toHeading({ headline: cmp.headline, subline: cmp.description }),
      media: this.imageService.normalizeMedia(cmp.media),
      mediaPosition: cmp?.mediaPosition ? (cmp.mediaPosition?.toLowerCase() as PositionEnum) : PositionEnum.right
    };
  }

  private toSeo(module: SeoModuleInterface): ISeo {
    return {
      title: module.headline,
      titleLevel: transformHeadlineLevelToTitleLevel(module.titleLevel),
      paragraphs: module.componentsObjects.map((cmp) => this.toParagraph(cmp)),
      hasReadMore: this.pageType !== 'NewGenerationTemplate'
    };
  }
}
